const c = {
  name: "Settings",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,14c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,14,20,14z M16,20c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4
			c0,2.2-1.8,4-4,4C17.8,24,16,22.2,16,20z"/>
		<path class="st0" d="M20,0c-1.3,0-2.6,0.1-3.9,0.4l-0.8,0.2l0,0.9c0.1,1.2-0.7,2.4-1.8,2.9c-1.2,0.5-2.5,0.2-3.3-0.7L9.6,2.9
			L8.9,3.4c-2.2,1.4-4,3.3-5.5,5.5L2.9,9.6l0.6,0.6c0.9,0.8,1.2,2.2,0.7,3.3c-0.5,1.2-1.7,1.9-2.9,1.8l-0.9,0l-0.2,0.8
			C0.1,17.4,0,18.7,0,20s0.1,2.6,0.4,3.9l0.2,0.8l0.9,0c1.2-0.1,2.4,0.7,2.9,1.8c0.5,1.2,0.2,2.5-0.7,3.3l-0.6,0.6l0.5,0.7
			c1.4,2.2,3.3,4,5.5,5.5l0.7,0.5l0.6-0.6c0.8-0.9,2.2-1.2,3.3-0.7c1.2,0.5,1.9,1.7,1.8,2.9l0,0.9l0.8,0.2c1.3,0.3,2.5,0.4,3.9,0.4
			c1.3,0,2.6-0.1,3.9-0.4l0.8-0.2l0-0.9c-0.1-1.2,0.7-2.4,1.8-2.9c1.2-0.5,2.5-0.2,3.3,0.7l0.6,0.6l0.7-0.5c2.2-1.4,4-3.3,5.5-5.5
			l0.5-0.7l-0.6-0.6c-0.9-0.8-1.2-2.2-0.7-3.3c0.5-1.2,1.7-1.9,2.9-1.8l0.9,0l0.2-0.8c0.3-1.3,0.4-2.5,0.4-3.9s-0.1-2.6-0.4-3.9
			l-0.2-0.8l-0.9,0c-1.2,0.1-2.4-0.7-2.9-1.8c-0.5-1.2-0.2-2.5,0.7-3.3l0.6-0.6l-0.5-0.7c-1.4-2.2-3.3-4-5.5-5.5l-0.7-0.5l-0.6,0.6
			c-0.8,0.9-2.2,1.2-3.3,0.7c-1.2-0.5-1.9-1.7-1.8-2.9l0-0.9l-0.8-0.2C22.6,0.1,21.3,0,20,0z M14.3,6.1c1.7-0.7,2.8-2.2,3-3.9
			C18.2,2.1,19.1,2,20,2s1.8,0.1,2.7,0.2c0.2,1.7,1.3,3.2,3,3.9c1.7,0.7,3.6,0.4,4.9-0.6c1.5,1.1,2.8,2.4,3.8,3.8
			c-1,1.4-1.3,3.2-0.6,4.9c0.7,1.7,2.2,2.8,3.9,3c0.1,0.9,0.2,1.8,0.2,2.7s-0.1,1.8-0.2,2.7c-1.7,0.2-3.2,1.3-3.9,3
			c-0.7,1.7-0.4,3.6,0.6,4.9c-1.1,1.5-2.4,2.8-3.8,3.8c-1.4-1-3.2-1.3-4.9-0.6c-1.7,0.7-2.8,2.2-3,3.9C21.8,37.9,20.9,38,20,38
			s-1.8-0.1-2.7-0.2c-0.2-1.7-1.3-3.2-3-3.9c-1.7-0.7-3.6-0.4-4.9,0.6c-1.5-1.1-2.8-2.4-3.8-3.8c1-1.4,1.3-3.2,0.6-4.9
			c-0.7-1.7-2.2-2.8-3.9-3C2.1,21.8,2,20.9,2,20s0.1-1.8,0.2-2.7c1.7-0.2,3.2-1.3,3.9-3c0.7-1.7,0.4-3.6-0.6-4.9
			c1.1-1.5,2.4-2.8,3.8-3.8C10.7,6.5,12.6,6.8,14.3,6.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Settings
};
